import { jsx, jsxs } from "react/jsx-runtime";
function SupportTicketCard(props) {
  const { status, ticketId, displayId, ticketUrl, ticketState, ticketTypeName, category, nextSteps, message } = props;
  if (status !== "success" || !ticketId) return null;
  const statePill = ticketState ? humanizeState(ticketState) : "Submitted";
  const ref = displayId ?? ticketId;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "tw:my-2 tw:rounded-xl tw:border tw:border-gray-200 tw:bg-white tw:p-4 tw:shadow-sm",
      role: "group",
      "aria-label": "Support ticket card",
      children: [
        /* @__PURE__ */ jsxs("div", { className: "tw:flex tw:items-start tw:justify-between tw:gap-3", children: [
          /* @__PURE__ */ jsxs("div", { className: "tw:flex tw:flex-col tw:gap-1", children: [
            /* @__PURE__ */ jsxs("div", { className: "tw:flex tw:items-center tw:gap-2", children: [
              /* @__PURE__ */ jsx("span", { className: "tw:text-xs tw:font-semibold tw:uppercase tw:tracking-wide tw:text-gray-500", children: "Ticket" }),
              /* @__PURE__ */ jsx(
                "span",
                {
                  className: "tw:rounded-full tw:px-2 tw:py-0.5 tw:text-xs tw:font-medium",
                  style: {
                    backgroundColor: "var(--bc-support-bg)",
                    color: "var(--bc-support-text)"
                  },
                  children: statePill
                }
              )
            ] }),
            /* @__PURE__ */ jsxs("div", { className: "tw:text-base tw:font-semibold tw:text-gray-900", children: [
              "#",
              ref
            ] }),
            (ticketTypeName || category) && /* @__PURE__ */ jsx("div", { className: "tw:text-xs tw:text-gray-500", children: [ticketTypeName, category].filter(Boolean).join(" · ") })
          ] }),
          ticketUrl && /* @__PURE__ */ jsx(
            "a",
            {
              href: ticketUrl,
              target: "_blank",
              rel: "noopener noreferrer",
              className: "tw:rounded-md tw:border tw:border-gray-200 tw:bg-gray-50 tw:px-3 tw:py-1.5 tw:text-xs tw:font-semibold tw:text-gray-700 tw:no-underline hover:tw:bg-gray-100",
              children: "View"
            }
          )
        ] }),
        nextSteps && /* @__PURE__ */ jsx("p", { className: "tw:mt-3 tw:text-sm tw:text-gray-700 tw:leading-relaxed", children: nextSteps }),
        !nextSteps && message && /* @__PURE__ */ jsx("p", { className: "tw:mt-3 tw:text-sm tw:text-gray-700 tw:leading-relaxed", children: message })
      ]
    }
  );
}
function SupportTicketCardFromRouteToSupport({
  output
}) {
  if (!output) return null;
  const text = typeof output === "string" ? output : output.reason ?? "";
  if (!text) return null;
  const match = /Ticket\s+#?([A-Za-z0-9_-]+)/.exec(text);
  if (!match) return null;
  return /* @__PURE__ */ jsx(
    SupportTicketCard,
    {
      status: "success",
      message: text,
      ticketId: match[1],
      displayId: match[1],
      ticketState: "submitted",
      nextSteps: text.replace(/^SUCCESS:\s*/, "")
    }
  );
}
function SupportTicketCardFromCreateTicket({
  output
}) {
  if (!output) return null;
  return /* @__PURE__ */ jsx(
    SupportTicketCard,
    {
      status: output.status,
      message: output.message,
      ticketId: output.ticketId,
      displayId: output.displayId,
      ticketUrl: output.ticketUrl,
      ticketState: output.ticketState,
      ticketTypeName: output.ticketTypeName,
      category: output.category,
      nextSteps: output.nextSteps
    }
  );
}
function humanizeState(state) {
  switch (state) {
    case "submitted":
      return "Submitted";
    case "in_progress":
      return "In progress";
    case "waiting_on_customer":
      return "Waiting on you";
    case "resolved":
      return "Resolved";
    case "closed":
      return "Closed";
    default:
      return state.replace(/_/g, " ");
  }
}
export {
  SupportTicketCard,
  SupportTicketCardFromCreateTicket,
  SupportTicketCardFromRouteToSupport
};
//# sourceMappingURL=SupportTicketCard.js.map
